/*
 * ProjectActivityListActions Messages
 * This contains all the text for the ProjectActivityListActions component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.activityList.actions';

export default defineMessages({
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  duplicate: {
    id: `${scope}.duplicate`,
    defaultMessage: 'Duplicate',
  },
  checkReport: {
    id: `${scope}.checkReport`,
    defaultMessage: 'Check for errors',
  },
  pPlusInDesign: {
    id: `${scope}.checkReport.pPlusInDesign`,
    defaultMessage: 'P+ and InDesign',
  },
  channelPartners: {
    id: `${scope}.checkReport.channelPartners`,
    defaultMessage: 'Channel Partners',
  },
  ePub: {
    id: `${scope}.duplicate.ePub`,
    defaultMessage: 'ePub',
  },
  bronteViewer: {
    id: `${scope}.duplicate.bronteViewer`,
    defaultMessage: 'Bronte Viewer',
  },
});
